module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '24z3y2st',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
